/**
 * @Medias BrackPoint:
 */
export const mediaScales = {
  brackpoint_2xl: '1550px',
  brackpoint_xl: '1439px',
  brackpoint_lg: '1100px',
  brackpoint_md: '668px',
  brackpoint_sm: '500px',
  brackpoint_xs: '350px',
} as const;
